import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router";

import UserIcon from "../../assets/Icons/admin-icon.svg";
import "./AdminPanelButton.scss";

interface TextProps {
	text: string;
	route: string;
}

export default function AdminPanelButton(props: TextProps) {
	const { text, route } = props;
	const navigator = useNavigate();

	return (
		<Button
			className="home__header__administrator"
			onClick={() => navigator(route)}
		>
			<img
				src={UserIcon}
				alt=""
			/>
			<Typography className="home__header__user__position">{text}</Typography>
		</Button>
	);
}
